import EcomCategoryNavs from 'components/navs/EcomCategoryNavs';
import { Col, Container, Row } from 'react-bootstrap';
import EcomWhopingBanner from 'components/banners/EcomWhopingBanner';
import EcomGiftItemsBanner from 'components/banners/EcomGiftItemsBanner';
import EcomBestInMarketBanner from 'components/banners/EcomBestInMarketBanner';
import {
  // allProducts,
  // bestOfferProducts,
  ProductCat,
  topDealsProducts,
  topElectronicProducts
} from 'data/e-commerce/products';
import ecom4 from 'assets/img/e-commerce/4.png';
import EcomTopDeals from 'components/sliders/EcomTopDeals';
import EcomTopElectronics from 'components/sliders/EcomTopElectronics';
import EcomBestOffers from 'components/sliders/EcomBestOffers';
import EcomBecomeMember from 'components/cta/EcomBecomeMember';
import EcomPromotionCount from 'components/banners/EcomPromotionCount';
import EcomCategoryWiseProducts from 'components/sliders/EcomCategoryWiseProducts';
import netflix from 'assets/img/brands/netflix.png';
import blender from 'assets/img/brands/blender.png';
import upwork from 'assets/img/brands/upwork.png';
import facebook from 'assets/img/brands/facebook.png';
import pocket from 'assets/img/brands/pocket.png';
import mailBluster from 'assets/img/brands/mail-bluster.png';
import discord from 'assets/img/brands/discord.png';
import google from 'assets/img/brands/google.png';
import dell from 'assets/img/brands/dell.png';
import honda from 'assets/img/brands/honda.png';
import xiaomi from 'assets/img/brands/xiaomi.png';
import intel from 'assets/img/brands/intel.png';
import asus from 'assets/img/brands/asus-rog.png';
import yamaha from 'assets/img/brands/yamaha.png';
import ibm from 'assets/img/brands/ibm.png';
import apple from 'assets/img/brands/apple-2.png';
import oppo from 'assets/img/brands/oppo.png';
import redragon from 'assets/img/brands/redragon.png';
import xbox from 'assets/img/brands/xbox.png';
import lenovo from 'assets/img/brands/lenovo.png';
import oneplus from 'assets/img/brands/oneplus-2.png';
import suzuki from 'assets/img/brands/suzuki-2.png';
import googleStore from 'assets/img/brands/google-store.png';
import hp from 'assets/img/brands/hp.png';
import { useQuery } from '@tanstack/react-query';
import {
  getBestSellerProduct,
  getProductsByCatTypes,
  HomeProductDetails
} from 'api/products/_requests';
import index from 'pages/faq/FaqTab';
import EcomBestSeller from 'components/sliders/EcomBestSeller';
import { getRecentViewedProducts } from 'api/user/_requests';
import EcomRecentProducts from 'components/sliders/EcomRecentProducts';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

const Homepage = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { data: categoryTypesProducts, isLoading: isCategoryTypesLoading } =
    useQuery<HomeProductDetails[]>({
      queryKey: ['products-by-some-categoryType'],
      queryFn: getProductsByCatTypes
    });

  const { data: bestSellerProduct, isLoading: isBestSellerLoading } = useQuery<
    ProductCat[]
  >({
    queryKey: ['best-Seller-Product'],
    queryFn: getBestSellerProduct
  });

  const { data: recentProduct, isLoading: isrecentLoading } = useQuery<
    ProductCat[]
  >({
    queryKey: ['recent-Products'],
    queryFn: getRecentViewedProducts,
    enabled: !!user || typeof window !== 'undefined',
    refetchOnMount: true,
    refetchOnWindowFocus: false,
    staleTime: 0
  });

  return (
    <div className="ecommerce-homepage pt-5 mb-9">
      <section className="py-0">
        <div className="container px-6">
          <div className="scrollbar">
            <EcomCategoryNavs />
          </div>
        </div>
      </section>
      <section className="py-0 px-xl-3">
        <Container className="px-xl-0 px-xxl-3">
          <Row className="g-3 mb-9">
            <Col xs={12}>
              <EcomWhopingBanner />
            </Col>
            <Col xs={12} xl={6}>
              <EcomGiftItemsBanner />
            </Col>
            <Col xs={12} xl={6}>
              <EcomBestInMarketBanner />
            </Col>
            <Col xs={12}>
              <EcomPromotionCount />
            </Col>
          </Row>
          <Row className="g-4 mb-6">
            <Col xs={12}>
              <EcomBestSeller products={bestSellerProduct || []} />
            </Col>
            <Col xs={12}>
              <EcomRecentProducts products={recentProduct || []} />
            </Col>
          </Row>

          {categoryTypesProducts?.map((item, index) => (
            <div className="mb-6" key={index}>
              <EcomCategoryWiseProducts
                category={item.categoryTypename || ''}
                products={item.products}
                brands={item.brands}
              />
            </div>
          ))}

          {/* <Col lg={3} xxl={2} className="d-none d-lg-block">
              <div className="h-100 position-relative rounded-3 overflow-hidden">
                <div
                  className="bg-holder product-bg"
                  style={{
                    backgroundImage: `url(${ecom4})`
                  }}
                />
              </div>
            </Col>
          </Row> */}
          {/* <div className="mb-6">
            <EcomTopElectronics products={topElectronicProducts} />
          </div>
          <div className="mb-6">
            <EcomBestOffers products={bestOfferProducts} />
          </div> */}
          <EcomBecomeMember />
        </Container>
      </section>
    </div>
  );
};

export default Homepage;
